import $ from 'jquery';
import 'select2';
import galerie from '../utils/galerie';
import initSwiper from '../utils/swiper';

const others = {
	init() {
		galerie.lightbox();
		this.programs();
		this.reviews();
		this.setupDarkSelects();
	},

	// Selects "Destination"/"Type of event" du formulaire contact/groupes
	// (PARTS/contact_form.php) - meme rendu select2 que le champ Country du
	// tunnel de vente (cf. cmd.js buildCountrySelect), classe partagee
	// ".__select_dark" plutot que reimplementer un style separe.
	setupDarkSelects() {
		const $selects = $('.__select_dark');
		if (!$selects.length) return;

		// select2 lit "data-placeholder" directement sur le <select> quand
		// present, pas besoin de le repeter ici (cf. contact_form.php).
		$selects.select2({
			allowClear: true,
			width: '100%',
			dropdownAutoWidth: false,
			dropdownCssClass: '__country_select2_dropdown'
		});
	},

	programs() {
		if (!document.querySelector('.__programs_swiper')) {
			return;
		}

		initSwiper('.__programs_swiper', {
			slidesPerView: 1.2,
			spaceBetween: 14,
			watchOverflow: true,
			navigation: true,
			navigationEls: {
				nextEl: '.__programs_next',
				prevEl: '.__programs_prev',
			},
			breakpoints: {
				576: {
					slidesPerView: 2.15,
					spaceBetween: 18,
				},
				992: {
					slidesPerView: 3.15,
					spaceBetween: 20,
				},
				1282: {
					slidesPerView: 3.2,
					spaceBetween: 22,
				},
			},
		});
	},

	reviews() {
		if (!document.querySelector('.__best_reviews_swiper')) {
			return;
		}

		initSwiper('.__best_reviews_swiper', {
			slidesPerView: 1.2,
			spaceBetween: 14,
			watchOverflow: true,
			navigation: true,
			navigationEls: {
				nextEl: '.__reviews_next',
				prevEl: '.__reviews_prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2.15,
					spaceBetween: 24,
				},
				1282: {
					slidesPerView: 3.15,
					spaceBetween: 28,
				},
			},
		});
	},
};

export default others;
